import { render, staticRenderFns } from "./AscUnauthorizedWrapper.vue?vue&type=template&id=42ffcb24&"
import script from "./AscUnauthorizedWrapper.vue?vue&type=script&lang=js&"
export * from "./AscUnauthorizedWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscUnauthorizedWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports